import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useUserInfo } from "@/model";
import "./index.less";

const extraPath: any = {
  "/service/announcement": [
    {
      title: "公告查看",
    }
  ],
  "/service/announcement/detail": [
    {
      href: "/service/announcement",
      title: "公告查看",
    },
    {
      title: "公告详情",
    }
  ]
}

const BreadcrumbC = () => {
  const userInfo = useUserInfo();
  const [breadcrumbData, setBreadcrumbData] = useState<any[]>([]);
  const location = useLocation();

  useEffect(() => {
    if (!userInfo.serviceMenuItems) return;
    const { pathname } = location;
    let curPaths: any[] = [];
    const dfs: (root: any, paths: any[]) => void = (root, paths) => {
      if (!root) return;
      const { comment, resources, children = [] } = root;
      const _paths = [...paths];
      if (resources === pathname) {
        _paths.push({
          title: comment,
        });
        curPaths = _paths;
        return;
      }
      if (resources) {
        _paths.push({
          title: comment,
          href: resources,
        });
      }
      children.forEach((el: any) => {
        dfs(el, _paths);
      });
    };

    dfs(userInfo.serviceMenuItems, []);

    curPaths.shift();

    if (curPaths.length === 0) {
      curPaths = extraPath[pathname] || [];
    }

    if (curPaths[0]?.title !== "服务中心") {
      curPaths.unshift({
        title: "服务中心",
        href: "/service/center",
      });
    }

    setBreadcrumbData(curPaths);
  }, [location, userInfo.serviceMenuItems]);

  return (
    <article className="breadcrumb-wrapper shop-pc">
      <div className="max-width">
        <div className="breadcrumb">
          {breadcrumbData.map(({ title, href }) =>
            href ? (
              <div key={title}>
                <Link to={href}>{title}</Link>
                <span className="separator">{">"}</span>
              </div>
            ) : (
              <span key={title}>{title}</span>
            )
          )}
        </div>
      </div>
    </article>
  );
};

export default BreadcrumbC;
